const Projects = () => import("Modules/projects/views/Projects");
const ProjectsForm = () => import("Modules/projects/views/ProjectsForm");

export default {
    children: [
        {
            path: "sales/projects",
            name: "projects",
            component: Projects,
            meta: {
                requiresAuth: true,
                title: "lang.projects",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["projects.read"],
            },
        },
        {
            path: "sales/project/profile/:id?",
            name: "project",
            component: ProjectsForm,
            meta: {
                requiresAuth: true,
                title: "lang.projects",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["projects.read"],
            },
        },
    ],
};
